import React from "react";
import Headline from "./Headline";
import { Card, Flex, notification } from "antd";
import HomeLink from "../../widgets/HomeLink";
import PostsApi from '../../api-services/posts-api.service';
import { mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import { Link } from "react-router-dom";
import { Post } from "../../interfaces/post.interface";
import PaginationWidget from "../../widgets/PaginationWidget";

const { Meta } = Card;

const LIMIT = 30;
const bannerPath = '/iceholidays-assets/images/whatsnew_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: "What's new" }
] 


export default class WhatsNewPage extends React.Component {
  api = new PostsApi;

  state = {
    posts: [],
    total: 0,
    currentPage: 1
  }

  componentDidMount() {
    this.getPosts();
  }


  getPosts(page=1){
    this.api.getPosts('whats_new', page, {limit: LIMIT})
      .then(({posts, total}) => {
        this.setState({posts, total, currentPage: page})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading GD Domestic.'});
      });
  }

  handlePageChange = (page) => {
    this.getPosts(page);
  }


  render(){
    return (
      <div id="whats-new" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            What's New?
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <div className="new-posts">
            {
              this.state.posts.map((item:Post) => (
                <Link to={`/web/new-posts/${item.id}`}>
                  <Card cover={<img alt={item.title} src={item.thumbnail} />}>
                      <Meta title={item.title} description={
                        <Flex align="flex-end" justify="space-between">
                          <div className="summary"> {item.summary} </div>
                          <div><Icon path={mdiMenuRight} size="40px" /></div>
                        </Flex>
                      } />
                  </Card>
                </Link>
              ))
            }
          </div>

          {this.state.total > 0 && <PaginationWidget totalItems={this.state.total} current={this.state.currentPage} maxItemsPerPage={LIMIT} pageChange={this.handlePageChange}/>}
        </div>

      </div>
    )
  }
}